import { render } from "./App.vue?vue&type=template&id=f84b5a6c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f84b5a6c&lang=scss"

import exportComponent from "/home/runner/work/maider_subscription/maider_subscription/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__